import Logger from "js-logger"
import {AxiosInstance, AxiosRequestConfig} from "axios"
import {appConfig} from "@/config/app.config"

const logger = Logger

logger.useDefaults({defaultLevel: (appConfig.IS_DEBUG || !appConfig.IS_TARGETING_PRODUCTION) ? Logger.TRACE : Logger.INFO})
const mode = appConfig.IS_DEBUG ? "debug" : "release"
logger.info(`Initializing app in ${mode} mode, targeting the ${appConfig.TARGET_ENVIRONMENT} environment...`)

export default logger

export function attachLoggerInterceptor(axiosInstance: AxiosInstance) {
    const getUrl = (requestConfig: AxiosRequestConfig) => {
        const url = (requestConfig.url as string)
        if (requestConfig.baseURL && url.startsWith(requestConfig.baseURL)) {
            return url.replace(requestConfig.baseURL, "")
        } else if (!url.startsWith("http")) {
            return "/" + requestConfig.url
        } else {
            return requestConfig.url
        }
    }

    // Intercept all requests
    axiosInstance.interceptors.request.use(
        (reqConfig) => {
            logger.debug(`%c${(reqConfig.method as string).toUpperCase()} - ${getUrl(reqConfig)}`,
                "color: #0086b3; font-weight: bold",
                reqConfig.data || "")
            return reqConfig
        },
        (error) => {
            return Promise.reject(error)
        },
    )

    // Intercept all responses
    axiosInstance.interceptors.response.use(
        (response) => {
            if (logger.enabledFor(logger.DEBUG)) {
                logger.debug(`%c${response.status} - ${getUrl(response.config)}:`,
                    "color: #008000; font-weight: bold",
                    response.data)
            }
            return response
        },

        (error) => {
            if (error.response) {
                logger.debug(`%c${error.response.status} - ${getUrl(error.response.config)}:`,
                    "color: #a71d5d; font-weight: bold",
                    error.response)
            }

            return Promise.reject(error)
        },
    )
}
